export const backendEnd = process.env.REACT_APP_BACKENDBASE;